module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    attrs: {
      "id": "flows-index"
    }
  }, [_c('div', {
    staticClass: "header-with-icon"
  }, [_c('div', {
    staticClass: "icon folder-icon"
  }), _c('div', {
    staticClass: "title-wrapper"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('flows.title.libFlows')))]), _c('span', {
    staticClass: "light-gray-text"
  }, [_vm._v(_vm._s(_vm.$t('flows.subtitle.libFlows')))])]), _c('div', {
    staticClass: "clear"
  }), _c('br'), _c('list', {
    attrs: {
      "list_item_options": _vm.list_item_options,
      "filter_options": _vm.filter_options,
      "options": _vm.options
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d6bab156!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/flows/library.vue
// module id = 1218
// module chunks = 1